import { Episode } from './episode';

export class Podcast {
    public id: string;
    public title: string;
    public description: string;
    public publisher: string;
    public image: string;
    public thumbnail: string;

    public totalEpisodes: number;

    public nextEpisodePubDate: number;

    public rssUrl: string;

    public episodes: Episode[];

    public static fromResponseData(data: object): Podcast {
        const podcast = new Podcast();

        podcast.id = data['id'];
        podcast.title = data['title'];
        podcast.description = data['description_original'] !== undefined ? data['description_original'].replace(/<[^>]*>/g, '') : data['description'].replace(/<[^>]*>/g, '');
        podcast.publisher = data['publisher'];
        podcast.image = data['image'];
        podcast.thumbnail = data['thumbnail'];

        podcast.totalEpisodes = data['total_episodes'];
        podcast.nextEpisodePubDate = data['next_episode_pub_date'];

        podcast.rssUrl = data['rss'];

        if (data['episodes']) {
            podcast.episodes = new Array();

            data['episodes'].forEach(element => {
                const episode = Episode.fromResponseData(element);
                episode.podcast = podcast;

                podcast.episodes.push(episode);
            });
        }

        return podcast;
    }
}